import React, { useState, useEffect } from "react";
import FullScreenLoader from "../components/FullScreeenLoader"
import { useStateContext } from "./ContextProvider";
import { Outlet, Navigate } from 'react-router-dom';
import { message } from "antd";

const RequireUser = ({ allowedRoles }) => {
    const { token, user, verificaUtilizator } = useStateContext();
    const [isLoading, setIsLoading] = useState(true);
    const [verificat, setVerificat] = useState(false);
    
    useEffect(() => {
        let isMounted = true;
        
        const verificare = async () => {
            if (!token) {
                setIsLoading(false);
                setVerificat(true);
                return;
            }
            
            setIsLoading(true);
            try {
                await verificaUtilizator();
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                    setVerificat(true);
                }
            }
        };
        
        verificare();
        
        return () => {
            isMounted = false;
        };
    }, [token, verificaUtilizator]);

    const showError = (comment) => {
        message.error(comment);
    }

    // Așteptăm până când verificarea tokenului este completă
    if (isLoading || !verificat) {
        return <FullScreenLoader />;
    }

    console.log(user);
    console.log(allowedRoles);
    // Verifică dacă utilizatorul are acces
    if (token && user && allowedRoles.includes(Number(user?.role_id))) {
        return <Outlet />;
    } else if (token && user) {
        showError(`Nu aveți acces la această pagină. Rolul dvs: ${user?.role_id}, Roluri permise: ${allowedRoles.join(', ')}`);
        return <Navigate to="/noaccess" replace />;
    } else {
        showError("Nu aveți acces la această pagină, va rugăm să vă autentificați");
        return <Navigate to="/login" replace />;
    }
}

export default RequireUser;